import { computed } from 'vue'
import store from '@/store'
import CapitalizationUtils from '@/utils/CapitalizationUtils'
import { TEATRO_HASH_MURCIA_PROMISES } from '@/constants/teatros'

export function useEventoImagen(props, modal) {
    const fecha_actual = computed(() => {
        const fecha = new Date()
        const fechaISO = fecha.toISOString().split('T')[0]
        const hora_actual = fecha.toTimeString().split(' ')[0]

        return `${fechaISO} ${hora_actual}`
    })

    const teatro = computed(() => {
        return store.getters.getTeatro
    })

    const url = computed(() => {
        return window.location.href
    })

    const tieneGastosInternosOnline = computed(() => {
        if (!props.event?.entradas_disponibles) {
            return false
        }

        // Murcia Promises regala invitaciones: una entrada sin gastos internos ni
        // online no se considera "con gastos", para que la tarjeta ofrezca
        // "Descargar invitaciones" en vez de "Comprar".
        const esMurciaPromises = teatro.value?.hash === TEATRO_HASH_MURCIA_PROMISES

        return props.event.entradas_disponibles.some(entrada => {
            if (entrada.price_management_online_interno !== 0) {
                return false
            }

            return !esMurciaPromises || entrada.price_management_online !== 0
        })
    })

    const toSlug = event => {
        return CapitalizationUtils.toKebabCase(event.name)
    }

    const showModal = nameModal => {
        modal.show(nameModal)
    }

    const closeModal = nameModal => {
        modal.hide(nameModal)
    }

    const getLinkTo = () => {
        if (props.event?.sesiones?.length === 1) {
            return {
                name: 'front.productos.show',
                params: {
                    slug: props.event.slug,
                    sesion_id: props.event.sesiones[0].id
                }
            }
        }

        return {
            name: 'front.productos.sesiones',
            params: {
                slug: props.event.slug
            }
        }
    }

    return {
        fecha_actual,
        teatro,
        url,
        tieneGastosInternosOnline,
        toSlug,
        showModal,
        closeModal,
        getLinkTo
    }
}
